import { render, staticRenderFns } from "./GrowthCentral.vue?vue&type=template&id=af678704&scoped=true"
import script from "./GrowthCentral.vue?vue&type=script&lang=js"
export * from "./GrowthCentral.vue?vue&type=script&lang=js"
import style0 from "./GrowthCentral.vue?vue&type=style&index=0&id=af678704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af678704",
  null
  
)

export default component.exports